module.exports = __webpack_public_path__ + "img/05_kudo_04.17594341.jpg";